import { Box, Button, TextField, Select, MenuItem, InputLabel, } from "@mui/material";
import {Formik} from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../components/global/Header";

import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { useState } from "react";
import useFetchCredential from "../../hooks/useFetchCredential";

axios.defaults.withCredentials = true;

const EditVisaRecord = () => {
    const isNoneMobile = useMediaQuery("(min-width:600px)");
    const { visaID } = useParams();
    const {data, loading, error} = useFetchCredential(`${process.env.REACT_APP_API_URL}/visas/visa/${visaID}`);
    const history = useNavigate();
    const [coverImage, setCoverImage] = useState();
    
    const initialValues = data ? {
        status: data.status,
    } : {
        status: ""
    }
    
    const validationSchema = yup.object().shape({
        status: yup.string().required("status Level is required")
    })

    const handleCoverImageChange = (e) => { 
        setCoverImage(e.target.files[0]);
    }

    const handleSubmit = (values) => {
        const formData = new FormData();
        formData.append('status', values.status);
        formData.append('coverImage', coverImage);
        axios.put(`${process.env.REACT_APP_API_URL}/visas/update-visa/${visaID}`, formData, { withCredentials: true})
        .then(res => {
            if(res.status === 200) {
                console.log("Successfully published data")
            } else {
                console.log("Failed")
            }
        })
        .then(()=>history("/visas"))
        .catch(err => console.log(err))
    }

    return <Box m="20px">
        <Box>
            <Header title="EDIT VISA RECORD" subtitle="Edit the opened visa record for the website" />    
        </Box>
        {data ? <Formik
            onSubmit={handleSubmit}
            initialValues={initialValues}
            validationSchema={validationSchema}
        >
            {
                ({ values, errors, touched, handleBlur, handleChange, handleSubmit}) => (
                    <form onSubmit={handleSubmit}>
                        <Box
                            display="grid"
                            gap="30px"
                            gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                            sx={{
                                "& > div": {
                                    gridColumn: isNoneMobile ? undefined : "span 4"
                                }
                            }}
                            m="40px 0 0 0"
                        >
                                                      

                            <Box
                                sx={{ gridColumn: "span 2", backgroundColor: "transparent", position: "relative"}}
                            >
                                <InputLabel id="select"
                                    sx={{
                                        position: "absolute",
                                        zIndex: "1",
                                        marginTop: "2px",
                                        paddingLeft: "10px"
                                    }}
                                >Select Visa Status</InputLabel>
                                <Select
                                    fullWidth
                                    variant="filled"
                                    labelId="select"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    value={values.status}
                                    name="status"
                                    error={!!touched.status && !!errors.status}
                                    sx={{ 
                                        backgroundColor: "transparent", 
                                        position: "absolute",
                                        zIndex: "111",
                                        top: "0px",
                                        height: "50px"
                                    }}
                                >
                                    <MenuItem value="Pending">Pending</MenuItem>
                                    <MenuItem value="Completed">Completed</MenuItem>
                                    <MenuItem value="Declined">Declined</MenuItem>
                                </Select>
                            </Box>

                            <TextField
                                fullWidth
                                variant="filled"
                                type="file"
                                label="Official Passport"
                                onBlur={handleBlur}
                                onChange={handleCoverImageChange}
                                name="coverImage"
                                sx={{ gridColumn: "span 2"}}
                                required
                            />
                        </Box>

                        <Box
                            display="flex"
                            justifyContent="end"
                            mt="20px"
                        >
                            <Button
                                type="submit"
                                color="secondary"
                                variant="contained"
                                sx={{
                                    fontSize: "16px",
                                    fontWeight: "600"
                                }}
                            >
                                Update Visa Record
                            </Button>
                        </Box>
                        
                    </form>
                )
            }
        </Formik> : null}
        {loading ? <div style={{color:"red !important", fontSize:"30px"}}>Loading...</div> : null}
        {error ? <div style={{color:"red !important", fontSize:"30px"}}>{error}</div> : null}
    </Box>
}
 
export default EditVisaRecord;